import React, { useState } from 'react';
import './contri.css';

const Cont = () => {
  const [college, setCollege] = useState('');
  const [semester, setSemester] = useState('');
  const [subject, setSubject] = useState('');
  const [image, setImage] = useState(null);
  const [file, setFile] = useState(null);

  const handleCollegeChange = (e) => {
    setCollege(e.target.value);
  };

  const handleSemesterChange = (e) => {
    setSemester(e.target.value);
  };

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here, e.g., send data to the server
    console.log({
      college,
      semester,
      subject,
      image,
      file,
    });
  };

  return (
    <div className="container">
      <h2 className='hel'>Contribute Here</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="college">College</label>
          <input
            type="text"
            className="form-control"
            id="college"
            value={college}
            onChange={handleCollegeChange}
            required
          /> 
        </div>
        <div className="form-group">
          <label htmlFor="semester">Semester</label>
          <select
            className="form-control"
            id="semester"
            value={semester}
            onChange={handleSemesterChange}
            required
          >
            <option value="">Select Semester</option>
            <option value="1">Semester 1</option>
            <option value="2">Semester 2</option>
            {/* Add more options as needed */}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input
            type="text"
            className="form-control"
            id="subject"
            value={subject}
            onChange={handleSubjectChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="image">Upload Image</label>
          <input
            type="file"
            className="form-control-file"
            id="image"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="file">Upload PDF/DOC/PPT</label>
          <input
            type="file"
            className="form-control-file"
            id="file"
            accept=".pdf,.doc,.docx,.ppt,.pptx"
            onChange={handleFileChange}
          />
        </div>
        <button type="submit" className="btns btn-primary">
          Submit
        </button>
      </form>
    </div>
  );
};

export default Cont;
